import { IconButton } from "@evergis/ui";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAddHandlers } from "./hooks/useAddHandlers";
import {
  EmptyBlockActions,
  EmptyBlockContainer,
  EmptyBlockDescription,
  EmptyBlockIcon,
  EmptyBlockTitle,
} from "./styled";
import { ProjectInfoBlock } from "./types";

export interface EmptyBlockProps {
  add: (block: ProjectInfoBlock) => void;
  items: ProjectInfoBlock[];
  setItems: (items: ProjectInfoBlock[]) => void;
}

export const EmptyBlock: FC<EmptyBlockProps> = ({ add, items, setItems }) => {
  const { t } = useTranslation("dialogs");

  const { options, onSelect } = useAddHandlers(add, setItems, items);

  return (
    <EmptyBlockContainer>
      <EmptyBlockIcon />
      <EmptyBlockTitle>{t("editResource.createMapDescription")}</EmptyBlockTitle>
      <EmptyBlockDescription>{t("editResource.mapDescriptionInfo")}</EmptyBlockDescription>
      <EmptyBlockActions>
        {options.map(option => (
          <IconButton key={option.icon} kind={option.icon} onClick={() => onSelect([option])}>
            {option.text}
          </IconButton>
        ))}
      </EmptyBlockActions>
    </EmptyBlockContainer>
  );
};
